// extracted by mini-css-extract-plugin
module.exports = {"calTitleCustom":"AreaRatio_calTitleCustom__3I7UH"};